<template>
  <section class="benefits">
    <p style="text-align: center; margin: 0">
      <img src="@/assets/logos/lions-loyal.png" alt="" width="75" />
    </p>
    <PageTitles h2="SEASON TICKET WAITLIST" />
    <section>
      <div class="new-benefits">
        <h3>
          <img src="@/assets/icons/new-benefits.svg" alt="" />
          <span class="blue">Frequently asked questions</span>
        </h3>
      </div>
    </section>
    <div class="additional-benefits">
      <EventTicket
        v-for="(item, id) in faqItems"
        :title="item.q"
        :description="item.a"
        isHtml
      />
    </div>
  </section>
  <div class="buttons">
    <router-link
      class="place-deposit"
      :to="{
        name: 'Waitlist',
      }"
      >Back</router-link
    >
    <a
      class="place-deposit"
      href="https://www.detroitlions.com/tickets/season-tickets/"
      target="_blank"
      >PLACE YOUR DEPOSIT NOW</a
    >
  </div>
</template>
<script setup>
import PageTitles from "@/components/PageTitles";
import EventTicket from "@/components/EventTicket";

const faqItems = [
  {
    q: "Why join the Detroit Lions Waitlist?",
    a: "Season tickets are sold out at Ford Field and by joining the Waitlist, you will have the earliest opportunity to secure season tickets once they become available.",
  },
  {
    q: "Is there a cost to joining the Detroit Lions Waitlist?",
    a: "Yes, there is a one-time deposit of $100 per seat (maximum of 4 seats) that is due after verifying your account. Placing a deposit does not guarantee specific seating come your turn in line. All deposits are non-refundable and nontransferable.",
  },
  {
    q: "What happens to my deposit?",
    a: "Your deposit will roll over year to year until your eventual purchase of season tickets",
  },
  {
    q: "How do I join the Detroit Lions Waitlist?",
    a: "You can join the Waitlist by signing up <a class='place-deposit' href='https://www.detroitlions.com/tickets/season-tickets/' target='_blank'>HERE</a>. After submitting your form, you will be required to verify your account to officially join the waitlist.",
  },
  {
    q: "Does joining the Waitlist guarantee season tickets for the following season?",
    a: "By joining the Waitlist, you will have the earliest opportunity to secure season tickets once they become available. However, by joining the Waitlist you are not guaranteed tickets for the upcoming season. Ticket availability will be determined after the current Lions Loyal Member renewal and relocation program each offseason. Waitlist members will be the first group contacted to acquire new season tickets following this process.",
  },
  {
    q: "How will I know if I have the opportunity to view available seats for the upcoming season?",
    a: "Ticket availability will be determined after the current Lions Loyal Member renewal and relocation process. If season tickets become available, accounts will have the opportunity to select seats based upon the order of which deposits were placed. You will receive an email informing you that your account will have the option to view available seats for the upcoming season.",
  },
  {
    q: "Is there a limit to how many deposits I can place?",
    a: "Yes, each account holder will only be able to place a maximum of (4) Waitlist deposits for (4) eventual season tickets.",
  },
  {
    q: "What if I want more than 4 season tickets?",
    a: "Please reach out to a Lions Ticket Representative directly at 313-262-2222.",
  },
  {
    q: "Can I add additional deposits to my account?",
    a: "Yes. At any time, you may add additional deposits to your account (maximum of 4 total per account). New deposits will be added as a separate rank at the end of the Waitlist. You will have the option to defer any deposits that receive a higher rank to the end of the Waitlist for the opportunity for all deposits to be together.",
  },
  {
    q: "When will I be notified of my standing on the Waitlist?",
    a: "Your priority will be updated once per year. You will receive an email after the current Lions Loyal Member renewal and relocation program if your account will have the option to select seats for the upcoming season.",
  },  
  {
    q: "Can I make a specific seating request?",
    a: "We cannot guarantee that specific seats will be available during your selection time. Once you become a Lions Loyal Member you will have the ability each offseason to upgrade your seating location based on availability.",
  },
  {
    q: "Will I be able to pick my seating location when offered seats?",
    a: "Waitlist members will be contacted in order of their priority with the opportunity to purchase new season tickets following the current Lions Loyal Member renewal and relocation program. You will be able to select seats from the available inventory when your opportunity arises.",
  },
  {
    q: "Will I be able to relocate my seating location in subsequent seasons?",
    a: "Each season, Lions Loyal Members who renew their account have the opportunity to relocate their seating locations based on availability. LLMs are able to view available seats and choose their new locations from the inventory that is available during your selection time.",
  },
  {
    q: "If I am contacted about season tickets and am unable to purchase at that time, can I decline?",
    a: "We encourage fans to purchase season tickets at their first opportunity. If for any reason, a Waitlist holder has passed on their opportunity to purchase seats twice, your account will be moved to the back of the Waitlist.",
  },
  {
    q: "What if I do not prefer the seating locations available at my time of selection, is my deposit refundable?",
    a: "We encourage fans to purchase the best available seating option at their first opportunity. Deposits are nonrefundable and nontransferable.",
  },
  {
    q: "Can I change the name on the account after it’s been created?",
    a: "Waitlist deposits are non-transferable.",
  },
  {
    q: "I have additional questions.",
    a: "Please reach out directly to our Detroit Lions Ticketing Team to learn more by calling 313-262-2222.",
  },
  
];
</script>
<style lang="scss" scoped>
.benefits {
  max-width: 1300px;
  margin: 0 auto;
  padding: 15px;
  > section {
    margin: 30px 0 40px;
  }
}
h2 {
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  font-size: 1.25rem;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  padding-bottom: 9px;
  span {
    padding-bottom: 6px;
    border-bottom: 4px solid #fff;
  }
}
.new-benefits {
  border-bottom: 1px solid #ffffff;
  display: block;
  align-items: center;
  margin-bottom: 25px;
  margin-left: 0px;
  @media (min-width: 800px) {
    display: flex;
    align-items: flex-end;
  }
  p {
    font-family: "United Sans SmCd";
    font-weight: 500;
    font-size: 1.375rem;
    color: #fff;
    span {
      font-family: "United Sans SmCd Hv";
      font-weight: 900;
    }
  }
}
h3 {
  position: relative;
  left: -11px;
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 1;
  text-transform: uppercase;
  color: #54585a;
  background: url("~@/assets/shapes/shape-new loyal-benefit.svg") no-repeat;
  background-size: contain;
  min-width: 350px;
  min-height: 53px;
  display: flex;
  display: block;
  align-items: center;
  gap: 15px;
  padding: 15px 18px;
  padding-bottom: 0;
  img,
  span {
    vertical-align: middle;
  }
  img {
    margin-right: 10px;
  }
  .blue {
    color: #0076b6;
  }
}
.additional-benefits {
  display: grid;
  row-gap: 6px;
  column-gap: 6px;
  grid-template-columns: 1fr;  
  align-items: baseline;
  justify-content: baseline;
  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1050px) {
    column-gap: 40px;
  }
  .event-ticket {
    width: 100%;
  }
}
.rewards-and-experiences {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 40px;
  @media (min-width: 800px) {
    flex-direction: row;
  }
  @media (min-width: 1050px) {
    gap: 80px;
  }
  > * {
    width: 100%;
  }
}
.links {
  max-width: 1060px;
  margin: 0 auto;
  text-align: center;
  a {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    border: 2px solid #fff;
    padding: 10px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #0076b6;
    background-color: #fff;
    font-size: 1.125rem;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 225px;
    gap: 8px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;

    img {
      transform: rotateY(180deg);
    }
  }
}
.buttons {
  display: flex;
  gap: 20px;
  margin-top: 70px;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    flex-direction: column;
  }
  .place-deposit {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    border: 2px solid #fff;
    padding: 10px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #0076b6;
    background-color: #fff;
    font-size: 1.125rem;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 225px;
    gap: 8px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 250px;
  }
}
:deep() {
  .event-ticket {
    height: 100%;
    .info {
      padding: 0 20px;
      .arrow {
        width: 20px;
      }
      .game {
        height: 72px;
        @media (max-width: 1100px) {
          height: 100px;
        }
        @media (max-width: 800px) {
          height: 100px;
        }
        .title {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
